import React from "react";
import {
  Box,
  Heading,
  useTheme,
  Link,
  VStack,
  Image,
  Text,
  Center,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

const InfoTopicBox = ({ image, title, description, link }) => {
  const theme = useTheme();

  return (
    <Box mb={5}>
    <Link as={RouterLink} to={link} style={{ textDecoration: "none" }}>
      <VStack
        spacing={4}
        align="center"
        justify="center"
        transition="transform 0.3s ease"
        _hover={{ transform: "scale(1.05)" }}
        mt={10}
      >
        <Center
          w={["200px", "180px", "200px"]}
          h={["200px", "180px", "200px"]}
          bg="white"
          borderRadius="full"
          borderWidth={5}
          boxShadow="2xl"
          overflow="hidden"
        >
          <Image
            src={image}
            alt={title}
            objectFit="cover"
            w="100%"
            h="100%"
          />
        </Center>
        <VStack spacing={1} align="center" maxW={["200px", "240px", "280px"]} mt={5}>
          <Heading
            size="md"
            color="gray.500"
            textAlign="center"
          >
            {title}
          </Heading>
          <Text
            fontSize={["sm", "md"]}
            color="gray.600"
            textAlign="center"
          >
            {description}
          </Text>
        </VStack>
      </VStack>
    </Link>
    </Box>
  );
};

export default InfoTopicBox;